import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import Get from "../../api/Get";
import Post from "../../api/Post";
import { DOCTOR_BY_EMAIL, DOCTOR_CREATE_SCHEDULE, DOCTOR_GET_SCHEDULE } from "../../api/Routes";
import AccionTimeDoctor from "../../components/doctor/agenda/AccionTimeDoctor";
import DatePickerDoctor from "../../components/doctor/agenda/DatePickerDoctor";
import DisponibilidadSpaceDoctor from "../../components/doctor/agenda/DisponibilidadSpaceDoctor";
import TitleDoctorAgenda from "../../components/doctor/agenda/TitleDoctorAgenda";
import { authContext } from "../../context/AuthContext";
import ModalSuccess from '../../components/ModalSuccess'
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever'

function DoctorMiAgenda({t}){
    const {auth} = useContext(authContext)
    const [fechaAgenda, setFechaAgenda] = useState(new Date())
    const [doctor, setDoctor] = useState(null)
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [timeIni, setTimeIni] = useState("")
    const [timeEnd, setTimeEnd] = useState("")
    const [scheduleType, setScheduleType] = useState("")
    const [blockedReason, setBlockedreason] = useState(null)
    const [submitCreate, setSubmitCreate] = useState(false)
    const [loadSchedule, setLoadSchedule] = useState(true)
    const [itemsSchedule, setItemsSchedule] = useState([])
    const [showSuccess, setShowSuccess] = useState(false)
    const [error, setError] = useState(false)

    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleCloseModalServer = () => setShowModalError(false)

    useEffect(()=>{
        let mounted = true;
        Get({url: `${DOCTOR_BY_EMAIL}/${auth.data.username}`, access_token: auth.data.access_token})
        .then(resp=>{
            if(mounted) {
                setDoctor(resp.data.data)
            }
        })
        .catch( error => {
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        });
        return () => mounted = false;
    },[])

    useEffect(()=>{        
        if(doctor){
            let mounted = true
            setLoadSchedule(true)
            Get({url: `${DOCTOR_GET_SCHEDULE}?order=ASC&id=${doctor.id}&dateScheduleInit=${moment(fechaAgenda).format("DD-MM-YYYY")}&dateScheduleEnd=${moment(fechaAgenda).format("DD-MM-YYYY")}`, access_token: auth.data.access_token})
            .then(response=>{
                if(mounted){
                    if(response.data.state){
                        setItemsSchedule(response.data.data.response)
                    }
                    setLoadSchedule(false)
                }
            })
            .catch( error => {
                setItemsSchedule([])
                setLoadSchedule(false)
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            });

            return () => mounted = false;
        }
    }, [fechaAgenda, doctor])



    const crearHorario = e =>{
        if(startDate === null || endDate === null || timeIni==='' || timeEnd === '' || doctor === null || scheduleType === ''){
            setError(true)
        }else if(scheduleType === 'Blocked' && blockedReason === null){
            setError(true)
        }else{
            setError(false)
            const data = {
                blockedReason: blockedReason,
                dateEnd: endDate ? moment(endDate).format("DD-MM-YYYY") : '',
                dateIni: startDate ? moment(startDate).format("DD-MM-YYYY") : '',
                idDoctor: doctor.id,
                scheduleType: scheduleType,
                timeIni: `${timeIni}:00`,
                timeEnd: `${timeEnd}:00`
            }
            //console.log(data)
            setSubmitCreate(true)
            Post({url: DOCTOR_CREATE_SCHEDULE, data:data, access_token: auth.data.access_token, header: true})
            .then(response=>{
                //console.log(response)
                if(response.data.state){
                    setStartDate(null)
                    setEndDate(null)
                    setTimeIni('')
                    setTimeEnd('')
                    setBlockedreason(null)
                    setShowSuccess(true)
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 2000);
                }
                setSubmitCreate(false)            
            })
            .catch(error=>{
                setSubmitCreate(false)
                setShowModalError(true)
                if(error.response){
                    setErrorServer(error.response)
                }
            })
        }
    }


    return(
        <Container fluid className="my-5">
            <Row className="mb-2">
                <Col><h2 className="mb-0 title-top agenda-title">Mi agenda</h2></Col>
            </Row>
            <Row>
                <Col xs="12" md="4">
                    <TitleDoctorAgenda doctor={doctor}/>
                    <div className="my-2"></div>
                    <DatePickerDoctor 
                        setFechaAgenda={setFechaAgenda}
                        locale={ auth?.data?.language }
                        startDate={startDate}
                        setStartDate={setStartDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        idDoctor={doctor?.id}
                        auth={auth}
                        setShowModalError={setShowModalError}
                        setErrorServer={setErrorServer}
                    />
                    <div className="my-2"></div>
                    <AccionTimeDoctor 
                        auth={auth}
                        timeIni={timeIni}
                        setTimeIni={setTimeIni}
                        timeEnd={timeEnd}
                        setTimeEnd={setTimeEnd}
                        setScheduleType={setScheduleType}
                        blockedReason={blockedReason}
                        setBlockedreason={setBlockedreason}
                        crearHorario={crearHorario}  
                        submitCreate={submitCreate}   
                        error={error}
                        idDoctor={doctor?.id}
                    />
                </Col>
                <Col xs="12" md="8">
                    <DisponibilidadSpaceDoctor 
                        fechaAgenda={fechaAgenda}
                        setFechaAgenda={setFechaAgenda}
                        loadSchedule={loadSchedule}
                        items={itemsSchedule}
                    />
                </Col>
            </Row>
            <ModalSuccess show={showSuccess} setShow={setShowSuccess}/>
            <ComponentModalErrorSever
                show={showModalError}
                handleClose={handleCloseModalServer}
                error={errorServer}
            />
        </Container>
    )

}

export default withTranslation()(DoctorMiAgenda)